import _cloneDeep from "lodash/cloneDeep";
import _isFinite from "lodash/isFinite";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import cn from 'classnames';
import React from 'react';
import { QuantityBlock } from 'swag-client-common/components/partials/quantity-block';
import { Button } from 'swag-client-common/components/ui/button';
import { DesignUploadMode } from 'swag-common/interfaces';
import applyQuantityToProduct from 'swag-common/utils/product/apply-quantity-to-product.util';
import getNotificationText from 'swag-common/utils/product/get-notification-text-for-product-quantity.util';
import { MIN_RELATED_AMOUNT } from '../../../../../redux/related-product-builder-popup/product.utils';
import classes from '../../regular-quantity-editor-popup.scss';
import { UpsellWidget } from '../upsell-widget';
import { getVariantsInStockLevels } from './get-selected-variants-in-stock-levels';
export class EditQuantity extends React.Component {
  constructor(props, context) {
    super(props, context);
    _defineProperty(this, "isValid", () => {
      const {
        item: {
          prod: {
            quantIncrement,
            isAlwaysInStock,
            productSize,
            hasSize,
            designUploadMode
          },
          sizeInd
        },
        maxQuant,
        stockLevelsByVariantSku,
        minQuant,
        relatedMinQuant
      } = this.props;
      const {
        variants,
        quantity,
        newBlendedQuantity,
        sharedItemInfo,
        sharedVariants
      } = this.state;
      const isRelated = _isFinite(relatedMinQuant);
      const mainQuantityValid = !getNotificationText({
        totalQuantityWithRelatedItems: isRelated ? newBlendedQuantity : null,
        quantityForCurrentItem: quantity,
        sharedQuantityForCurrentItem: sharedItemInfo.totalQuantity,
        maxQuantity: maxQuant,
        minQuantity: minQuant,
        variants: variants,
        stockLevelsByVariantSku: stockLevelsByVariantSku,
        quantIncrement: isRelated ? 1 : quantIncrement,
        productIsAlwaysInStock: isAlwaysInStock,
        isShared: sharedItemInfo.isSharedItem
      });
      const isEveryVariantValid = variants.every(variant => {
        const {
          quantities,
          variantIndex
        } = variant;
        const sharedVariant = sharedVariants.find(v => v.variantIndex === variantIndex);
        const {
          quantities: sharedQuantities
        } = sharedVariant;
        const isWithSizes = quantities.length > 1 && hasSize && productSize && designUploadMode !== DesignUploadMode.fullDesign;
        const baseData = {
          minQuantity: isRelated ? MIN_RELATED_AMOUNT : 0,
          maxQuantity: maxQuant,
          stockLevelsByVariantSku: stockLevelsByVariantSku,
          quantIncrement: isRelated ? 1 : quantIncrement,
          productIsAlwaysInStock: isAlwaysInStock,
          isShared: sharedItemInfo.isSharedItem
        };
        if (isWithSizes) {
          const optionsWithValues = productSize.options.filter((sizeLabel, index) => quantities[index]);
          return optionsWithValues.every((sizeLabel, index) => !getNotificationText(_objectSpread({
            quantityForCurrentItem: quantities[index],
            sharedQuantityForCurrentItem: sharedQuantities[index],
            variants: [_objectSpread({}, variant, {
              productSku: variant.sizeSkus[sizeLabel]
            })]
          }, baseData)));
        }
        return !getNotificationText(_objectSpread({
          quantityForCurrentItem: quantities && quantities[sizeInd],
          sharedQuantityForCurrentItem: sharedQuantities && sharedQuantities[sizeInd],
          variants: [variant]
        }, baseData));
      });
      return mainQuantityValid && isEveryVariantValid && quantity > 0;
    });
    const {
      item: {
        quantity: _quantity,
        blendedQuantity
      },
      variants: _variants,
      sharedVariants: _sharedVariants,
      sharedItemInfo: _sharedItemInfo
    } = props;
    this.state = {
      variants: _variants,
      sharedVariants: _sharedVariants,
      sharedItemInfo: _sharedItemInfo,
      quantity: _quantity,
      newBlendedQuantity: blendedQuantity,
      oldQuantity: _quantity
    };
    this.handleClickSave = this.handleClickSave.bind(this);
    this.handleClickCancel = this.handleClickCancel.bind(this);
    this.handleChangeQuantity = this.handleChangeQuantity.bind(this);
    this.handleGeneralQuantityChange = this.handleGeneralQuantityChange.bind(this);
  }
  handleChangeQuantity(value, variantIndex, sizeIndex) {
    const {
      state: {
        variants,
        oldQuantity,
        sharedVariants,
        sharedItemInfo
      },
      props: {
        item: {
          asRelatedItemId,
          blendedQuantity
        }
      }
    } = this;
    const updatedVariants = _cloneDeep(variants);
    const updatedSharedVariants = _cloneDeep(sharedVariants);
    const index = updatedVariants.findIndex(variant => variant.variantIndex === variantIndex);
    updatedVariants[index].quantities[sizeIndex] = +value;
    if (sharedVariants) {
      const oldVariantQuantity = variants[index].quantities[sizeIndex];
      const oldSharedVariantQuantity = sharedVariants[index].quantities[sizeIndex];
      updatedSharedVariants[index].quantities[sizeIndex] = oldSharedVariantQuantity - oldVariantQuantity + value;
    }
    const quantity = updatedVariants.reduce((all, nextVariant) => {
      const quantityPerVariant = Object.values(nextVariant.quantities).reduce((allQuantity, nextItem) => {
        if (nextItem) {
          return allQuantity + nextItem;
        }
        return allQuantity;
      }, 0);
      return all + quantityPerVariant;
    }, 0);
    let newBlendedQuantity = quantity;
    if (asRelatedItemId) {
      newBlendedQuantity = blendedQuantity + quantity - oldQuantity;
    }
    const newSharedItemInfo = _cloneDeep(sharedItemInfo);
    if (sharedItemInfo !== null && sharedItemInfo !== void 0 && sharedItemInfo.isSharedItem) {
      newSharedItemInfo.totalQuantity = newBlendedQuantity;
      newSharedItemInfo.sharedItemsInfo[0].quantity = quantity;
    }
    if (quantity.toString().length < 7) {
      this.setState({
        quantity,
        sharedItemInfo: newSharedItemInfo,
        newBlendedQuantity,
        variants: updatedVariants,
        sharedVariants: updatedSharedVariants
      });
    }
  }
  handleGeneralQuantityChange(quantity) {
    if (quantity.toString().length >= 7) {
      return;
    }
    const {
      size,
      sharedItemInfo,
      stockLevelsByVariantSku,
      item: {
        prod,
        sizeInd,
        blendedQuantity,
        asRelatedItemId
      }
    } = this.props;
    const {
      variants,
      sharedVariants,
      oldQuantity
    } = this.state;
    let newBlendedQuantity = quantity;
    if (asRelatedItemId) {
      newBlendedQuantity = blendedQuantity + (quantity - oldQuantity);
    }
    const newSharedItemInfo = _cloneDeep(sharedItemInfo);
    if (sharedItemInfo !== null && sharedItemInfo !== void 0 && sharedItemInfo.isSharedItem) {
      newSharedItemInfo.totalQuantity = newBlendedQuantity;
      newSharedItemInfo.sharedItemsInfo[0].quantity = quantity;
    }
    const selectedVariantsInStockLevels = getVariantsInStockLevels(prod, variants, stockLevelsByVariantSku);
    const newQuantities = applyQuantityToProduct({
      product: prod,
      quantity,
      selectedVariants: variants.map(v => v.variantIndex),
      selectedSizeIndex: sizeInd,
      sizeSettings: size,
      selectedVariantsInStockLevels: selectedVariantsInStockLevels,
      threshold: 0
    });
    const newVariants = variants.map(v => _objectSpread({}, v, {
      quantities: newQuantities[v.variantIndex]
    }));
    const newSharedVariants = sharedVariants === null || sharedVariants === void 0 ? void 0 : sharedVariants.map((v, i) => _objectSpread({}, v, {
      quantities: v.quantities.map((q, j) => {
        if (!variants[i]) {
          return q;
        }
        return q - variants[i].quantities[j] + newVariants[i].quantities[j];
      })
    }));
    this.setState({
      variants: newVariants,
      sharedVariants: newSharedVariants,
      sharedItemInfo: newSharedItemInfo,
      quantity,
      newBlendedQuantity
    });
  }
  handleClickSave() {
    const {
      onSave,
      item,
      recalculateOrder
    } = this.props;
    const {
      variants,
      quantity,
      newBlendedQuantity
    } = this.state;
    const filteredVariants = variants.map(({
      quantities,
      variantIndex
    }) => ({
      quantities,
      variantIndex
    }));
    const params = _objectSpread({}, item, {
      variants: filteredVariants,
      blendedQuantity: quantity,
      quantity
    });
    if (item.asRelatedItemId) {
      params.blendedQuantity = newBlendedQuantity;
    }
    onSave(params, recalculateOrder);
  }
  handleClickCancel() {
    const {
      onClose
    } = this.props;
    onClose();
  }
  render() {
    const {
      item: {
        prod: {
          sizeDependentPrice,
          hasSize,
          quantIncrement,
          isAlwaysInStock
        },
        sizeInd
      },
      size,
      isRelated,
      minQuant,
      maxQuant,
      sharedItemInfo: originalSharedItemInfo,
      stockLevelsByVariantSku,
      inputClassName,
      sizeItemLabelClassName
    } = this.props;
    const {
      variants,
      quantity,
      newBlendedQuantity,
      sharedVariants,
      sharedItemInfo
    } = this.state;
    const isValid = this.isValid();
    return /*#__PURE__*/React.createElement("div", {
      className: classes.content
    }, /*#__PURE__*/React.createElement(QuantityBlock, {
      ignoreBigNumber: true,
      beforeMainInputText: "I would like",
      afterMainInputText: "printed",
      productIsAlwaysInStock: isAlwaysInStock,
      variants: variants,
      selectedSize: sizeInd,
      totalQuantity: quantity,
      quantIncrement: quantIncrement,
      sizeContainerClassName: classes.container,
      size: size && size || {
        options: ['']
      },
      quantityPerColorEnabled: variants.length > 1,
      maxQuant: maxQuant,
      minQuant: minQuant,
      sizeItemLabelClassName: sizeItemLabelClassName,
      quantityPerSizeEnabled: !sizeDependentPrice && hasSize,
      inputClassName: cn(classes.input, inputClassName),
      titleClassName: classes.title,
      subTitleClassName: classes.subTitle,
      sizeItemClassName: classes.sizeItem,
      sizeItemInputClassName: classes.sizeItemInput,
      sizeItemInputWrapperClassName: classes.sizeItemWrapperInput,
      errorClassName: classes.error,
      validateQuantity: isRelated ? newBlendedQuantity : quantity,
      isRelated: isRelated,
      stockLevelsByVariantSku: stockLevelsByVariantSku,
      onGeneralQuantityChange: this.handleGeneralQuantityChange,
      onSingleQuantityChange: this.handleChangeQuantity,
      onColorQuantityChange: (value, variantIndex) => this.handleChangeQuantity(value, variantIndex, sizeInd),
      componentAfterMainQuantityInput: /*#__PURE__*/React.createElement(UpsellWidget, {
        quantity: quantity,
        blendedQuantity: newBlendedQuantity
      }),
      sharedItemInfo: sharedItemInfo,
      originalSharedItemInfo: originalSharedItemInfo,
      sharedVariants: sharedVariants
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      dataButton: "Save",
      className: classes.button,
      type: "primary",
      disabled: !isValid,
      onClick: this.handleClickSave
    }, "Save"), /*#__PURE__*/React.createElement(Button, {
      dataButton: "Cancel",
      className: cn(classes.button, classes.cancelButton),
      type: "grey",
      onClick: this.handleClickCancel
    }, "Cancel")));
  }
}